/* eslint no-underscore-dangle: ["error", { "allow": [ "_id"] }] */
import React, { useEffect, useState } from 'react';
import { Box, Button, Typography, Chip } from '@mui/material';
import PropTypes from 'prop-types';
import { DataGrid } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

function QuickSearchToolbar() {
  return (
    <Box
      className="tableTopWrap page__title"
      sx={{
        borderBottom: '1px solid rgba(0,0,0,0.1)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        p: 2
      }}
    >
      <Typography sx={{ fontSize: '16px', fontWeight: '700' }}>Recent Transactions </Typography>
      <Button
        variant="text"
        size="small"
        sx={{ p: '0!important', minWidth: 'auto!important' }}
        endIcon={<ChevronRightIcon />}
        component={Link}
        to="/transaction"
        color="secondary"
      >
        Show All
      </Button>
    </Box>
  );
}

function RecentTransaction({ data }) {
  const [tableData, setTableData] = useState([]);

  const columns = [
    {
      field: 'invoice_number',
      headerName: 'Invoice Number',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      sortable: false
    },
    {
      field: 'name',
      headerName: 'Client',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      sortable: false
    },
    {
      field: 'amount',
      headerName: 'Amount',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        if ((params && params.value) || (params.row && params.row.symbol)) {
          return (
            <Typography component="p" variant="body1" sx={{ fontSize: '14px', fontWeight: '700' }}>
              {`${params.row.short_name} ${params.value}`}
            </Typography>
          );
        }
        return null;
      }
    },
    {
      field: '_created_at',
      headerName: 'Paid Date',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        if (params && params.value) {
          return (
            <Typography component="p" variant="body1" sx={{ fontSize: '14px', fontWeight: '700' }}>
              {params.value}
            </Typography>
          );
        }
        return null;
      }
    },
    {
      field: 'status',
      headerName: 'Status',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        if (params && params.value) {
          return (
            <Chip label={params.value} color={params.value.toLowerCase().replace(/\s+/g, '')} />
          );
        }
        return null;
      }
    }
  ];

  useEffect(() => {
    if (data && data.length > 0) {
      setTableData(data);
    } else {
      setTableData([]);
    }
  }, [data]);

  const tableStyle = {
    bgcolor: 'white',
    '& .super-app-theme--header': {
      backgroundColor: 'primary.main',
      color: '#fff',
      '.MuiDataGrid-columnHeaderTitle': {
        fontWeight: '700',
        fontSize: '14px'
      }
    }
  };

  return (
    <Box sx={tableStyle} className="dashtableWrapper">
      <DataGrid
        disableColumnSorting
        rows={tableData}
        getRowId={(row) => row._id}
        columns={columns}
        disableColumnSelector
        disableColumnMenu
        autoHeight
        disableColumnFilter
        hideFooter
        rowHeight={40}
        columnHeaderHeight={40}
        slots={{
          toolbar: QuickSearchToolbar
        }}
      />
    </Box>
  );
}

// RecentTransaction.defaultProps = {
//   data: {
//     invoice_number: '24/04/006',
//     amount: '0',
//     status: 'Paid',
//     symbol: '$',
//     name: 'name',
//     created_at: '2024-04-26T09:37:13.000000Z'
//   }
// };

RecentTransaction.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      invoice_number: PropTypes.string.isRequired,
      amount: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired,
      short_name: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      _created_at: PropTypes.string.isRequired
      // Add other properties expected in the object
    })
  ).isRequired
};

export default RecentTransaction;
